import { FC } from "react";
import { InformationBox, MuiGrid } from "../../../../../components";
import { useSiteCore } from "../../../../../hooks/useSiteCore";
import { ParticipantsSearchHeaderWrapper } from "./ParticipantsSearchHeader.style";

export const ParticipantsSearchHeader: FC = () => {
  const { pageTitle } = useSiteCore();

  return (
    <ParticipantsSearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
      </MuiGrid>
    </ParticipantsSearchHeaderWrapper>
  );
};
